export enum BillingAmountUpdateMethod {
  None,
  FixedAmount,
  Percentage,
  PricingCalculation,
  MembershipLevel,
}
